<div class="zag-card-footer">
  <ng-content></ng-content>
</div>
